import { render, staticRenderFns } from "./SubcategoriesView.vue?vue&type=template&id=3d7acc56&"
import script from "./SubcategoriesView.vue?vue&type=script&lang=ts&"
export * from "./SubcategoriesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports